import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as ChartActions from '../actions/chart.actions';
import { ElasticSearchService } from '../../service/elastic-search.service';

@Injectable()
export class ChartEffects {

  constructor(
    private actions: Actions,
    private _elasticSearchService: ElasticSearchService
  ) { }

  getChartCountDoneLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCountDoneLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphCountDoneLilates(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCountDoneLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCountDoneLilatesFailure()))
      );
    })
  ));

  getChartCountDoneLilatesByStart = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCountDoneLilatesByStart),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphCountDoneLilates(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCountDoneLilatesByStartSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCountDoneLilatesByStartFailure()))
      );
    })
  ));

  getChartCountCreatedLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCountCreatedLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphCreatedLilates(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCountCreatedLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCountCreatedLilatesFailure()))
      );
    })
  ));

  getChartMonthlyCreatedLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCountMonthlyCreatedLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphMonthlyCreatedLilates(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCountMonthlyCreatedLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCountMonthlyCreatedLilatesFailure()))
      );
    })
  ));

  getChartEvolutionMonthlyCreatedLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionMonthlyCreatedLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphMonthlyCreatedLilates(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetEvolutionMonthlyCreatedLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetEvolutionMonthlyCreatedLilatesFailure()))
      );
    })
  ));

  getChartCheckDataByYearLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCheckDataByYearLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateCheckDataByYear().pipe(
        map((data: any) => {
          return ChartActions.GetCheckDataByYearLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCheckDataByYearLilatesFailure()))
      );
    })
  ));

  getChartLanguagesLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetLanguagesLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateLanguages(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetLanguagesLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetLanguagesLilatesFailure()))
      );
    })
  ));

  getChartTauxPassageLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetTauxPassageLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateTauxPassage(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetTauxPassageLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetTauxPassageLilatesFailure()))
      );
    })
  ));

  getChartSuccessLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetSuccessLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateSuccess(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetSuccessLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetSuccessLilatesFailure()))
      );
    })
  ));

  getTauxPassageLilatesPerLangues = createEffect(() =>
    this.actions.pipe(
      ofType(ChartActions.GetTauxPassageLilatesPerLangues),
      exhaustMap((action) => {
        const params: HttpParams = action.params; // Vous pouvez ajouter des paramètres ici si nécessaire

        return this._elasticSearchService.getGraphLilateTauxPassagePerLangues(params).pipe(
          map((data: any) => {
            return ChartActions.GetTauxPassageLilatesPerLanguesSuccess({ data });
          }),
          catchError(() => of(ChartActions.GetTauxPassageLilatesPerLanguesFailure()))
        );
      })
    )
  );

  getSuccessLilatesPerLangues = createEffect(() =>
    this.actions.pipe(
      ofType(ChartActions.GetSuccessLilatesPerLangues),
      exhaustMap((action) => {
        const params: HttpParams = action.params; // Vous pouvez ajouter des paramètres ici si nécessaire

        return this._elasticSearchService.getGraphLilateSuccessPerLangues(params).pipe(
          map((data: any) => {
            return ChartActions.GetSuccessLilatesPerLanguesSuccess({ data });
          }),
          catchError(() => of(ChartActions.GetSuccessLilatesPerLanguesFailure()))
        );
      })
    )
  );

  getChartStatusLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetStatusLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateStatus(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetStatusLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetStatusLilatesFailure()))
      );
    })
  ));

  getChartLevelLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetLevelLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateLevel(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetLevelLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetLevelLilatesFailure()))
      );
    })
  ));

  getChartLevelPerLanguagesLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetLevelPerLanguagesLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateLevelPerLanguages(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetLevelPerLanguagesLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetLevelPerLanguagesLilatesFailure()))
      );
    })
  ));

  getChartNpsLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetNpsLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateNps(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetNpsLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetNpsLilatesFailure()))
      );
    })
  ));

  getChartCsatLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCsatLilates),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphLilateCsat(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCsatLilatesSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCsatLilatesFailure()))
      );
    })
  ));

  getChartCarbon = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetCarbon),
    exhaustMap(action => {
      return this._elasticSearchService.getGraphCarbon(action.params).pipe(
        map((data: any) => {
          return ChartActions.GetCarbonSuccess({ data });
        }),
        catchError(() => of(ChartActions.GetCarbonFailure()))
      );
    })
  ));

  getChartModesFinancement = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetModeFinancement),
    exhaustMap(action => {
      return this._elasticSearchService.GetModeFinancement(action.params)
        .pipe(map((data: any) => {
          return ChartActions.GetModeFinancementSuccess({ data });
        }),
          catchError(() => of(ChartActions.GetModeFinancementFailure()))
        );
    })
  ));

  getChartGenderLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetGenderLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphGenderLilates(action.params).pipe(
        map(data => ChartActions.GetGenderLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetGenderLilatesFailure()))
      )
    )
  ));

  getChartJobSituationLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetJobSituationLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphJobSituationLilates(action.params).pipe(
        map(data => ChartActions.GetJobSituationLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetJobSituationLilatesFailure()))
      )
    )
  ));

  getChartInTrainingLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetInTrainingLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphInTrainingLilates(action.params).pipe(
        map(data => ChartActions.GetInTrainingLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetInTrainingLilatesFailure()))
      )
    )
  ));

  getChartIdentityIssueCountLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetIdentityIssueCountLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphIdentityIssueCountLilates(action.params).pipe(
        map(data => ChartActions.GetIdentityIssueCountLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetIdentityIssueCountLilatesFailure()))
      )
    )
  ));

  getChartPhotoStatusRefusedCountLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetPhotoStatusRefusedCountLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphPhotoStatusRefusedCountLilates(action.params).pipe(
        map(data => ChartActions.GetPhotoStatusRefusedCountLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetPhotoStatusRefusedCountLilatesFailure()))
      )
    )
  ));

  getChartUniqueCompaniesCountLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetUniqueCompaniesCountLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphUniqueCompaniesCountLilates(action.params).pipe(
        map(data => ChartActions.GetUniqueCompaniesCountLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetUniqueCompaniesCountLilatesFailure()))
      )
    )
  ));

  getChartAverageAgeLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetAverageAgeLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphAverageAgeLilates(action.params).pipe(
        map(data => ChartActions.GetAverageAgeLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetAverageAgeLilatesFailure()))
      )
    )
  ));

  getChartAgeRangeCountLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetAgeRangeCountLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphAgeRangeCountLilates(action.params).pipe(
        map(data => ChartActions.GetAgeRangeCountLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetAgeRangeCountLilatesFailure()))
      )
    )
  ));

  getChartJobLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetJobLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphJobLilates(action.params).pipe(
        map(data => ChartActions.GetJobLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetJobLilatesFailure()))
      )
    )
  ));

  getChartBusinessLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetBusinessLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphBusinessLilates(action.params).pipe(
        map(data => ChartActions.GetBusinessLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetBusinessLilatesFailure()))
      )
    )
  ));

  getChartEvolutionCreatedLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionCreatedLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphCreatedLilates(action.params).pipe(
        map(data => ChartActions.GetEvolutionCreatedLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetEvolutionCreatedLilatesFailure()))
      )
    )
  ));

  getChartEvolutionDoneLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionDoneLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphCountDoneLilates(action.params).pipe(
        map(data => ChartActions.GetEvolutionDoneLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetEvolutionDoneLilatesFailure()))
      )
    )
  ));

  getChartEvolutionDoneLilatesByStart = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionDoneLilatesByStart),
    exhaustMap(action =>
      this._elasticSearchService.getGraphCountDoneLilates(action.params).pipe(
        map(data => ChartActions.GetEvolutionDoneLilatesByStartSuccess({ data })),
        catchError(() => of(ChartActions.GetEvolutionDoneLilatesByStartFailure()))
      )
    )
  ));

  getChartEvolutionSuccessLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionSuccessLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphLilateSuccess(action.params).pipe(
        map(data => ChartActions.GetEvolutionSuccessLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetEvolutionSuccessLilatesFailure()))
      )
    )
  ));

  getChartEvolutionTauxPassageLilates = createEffect(() => this.actions.pipe(
    ofType(ChartActions.GetEvolutionTauxPassageLilates),
    exhaustMap(action =>
      this._elasticSearchService.getGraphLilateTauxPassage(action.params).pipe(
        map(data => ChartActions.GetEvolutionTauxPassageLilatesSuccess({ data })),
        catchError(() => of(ChartActions.GetEvolutionTauxPassageLilatesFailure()))
      )
    )
  ));
}
